export const getIBE_API = () => {
    //return "https://localhost:44302/api"
    return "https://ibe-qa-api.securedreservations.com/api"
}